<template>
    <div style="margin: 20px;">
        <card-tit :data="cardData"/>
        <Card :padding="20" style="margin: 20px 0">
            <Menu mode="horizontal" :theme="'light'" active-name="courseLearn" class="tabs" @on-select="menuChange">
                <MenuItem name="courseLearn">
                    课程学习情况
                </MenuItem>
                <MenuItem name="labLearn">
                    实验上机情况
                </MenuItem>
            </Menu>
            <keep-alive>
                <component :is="chartPage"></component>
            </keep-alive>

        </Card>
    </div>
</template>

<script>
    import cardTit from '../common/cardTit'
    import courseLearn from "./chart/courseLearn";
    import labLearn from "./chart/labLearn";
    export default {
        name: "classChart",
        components: {
            cardTit,
            courseLearn,
            labLearn
        },
        data(){
            return{
                cardData:[
                    {
                        title:'累计课程总数',
                        number:'9',
                        unit:'门',
                        width:5,
                    },
                    {
                        title:'所含实验数量',
                        number:'3',
                        unit:'个',
                        width:5,
                    },
                    {
                        title:'累计学习人数',
                        number:'2',
                        unit:'次',
                        width:5,
                    },{
                        title:'累计学习总人次',
                        number:'25',
                        unit:'次',
                        width:5,
                    },
                    {
                        title:'累计上机次数',
                        number:'25',
                        unit:'次',
                        width:4,
                    }
                ],
                chartPage:'courseLearn'
            }
        },
        methods: {
            menuChange(name){
                this.chartPage = name
            }
        }
    }
</script>

<style scoped lang="less">

</style>